import __base_store from '@/store/__base_store'

/**
 * Store de comisiones de promoción de vinoteca (modelo `promocion_vinoteca_commission`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'promocion_vinoteca_commission',
	},
})

